import { render, staticRenderFns } from "./crm-customers.vue?vue&type=template&id=d31c45b0&scoped=true&"
import script from "./crm-customers.vue?vue&type=script&lang=js&"
export * from "./crm-customers.vue?vue&type=script&lang=js&"
import style0 from "./crm-customers.vue?vue&type=style&index=0&id=d31c45b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31c45b0",
  null
  
)

export default component.exports